import axios from 'axios';
import { createAssigneeQuery } from './queries';

const addAssignee = (model) =>
    new Promise((resolve, reject) => {
        const query = createAssigneeQuery({ model });
        const request = axios.post(query.url, { ...query.body });

        request
            .then((response) => {
                resolve({ data: response.data });
            })
            .catch((errors) => {
                // eslint-disable-next-line no-console
                console.log(errors);
                reject(new Error('Unable to add assignee'));
            });
    });

export default addAssignee;
